import { render, staticRenderFns } from "./AffiliateDashboardTable.vue?vue&type=template&id=3e47ebff&scoped=true&"
import script from "./AffiliateDashboardTable.vue?vue&type=script&lang=js&"
export * from "./AffiliateDashboardTable.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateDashboardTable.vue?vue&type=style&index=0&id=3e47ebff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e47ebff",
  null
  
)

export default component.exports